import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=cafaa2ec&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=ts&"
export * from "./Rule.vue?vue&type=script&lang=ts&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=cafaa2ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafaa2ec",
  null
  
)

export default component.exports